<template>
  <div>
    <Header />
    <div style="padding-left: 30px; padding-right: 30px; padding-bottom: 80px">
      <br />
      <el-alert
        show-icon
        :closable="false"
        title="FELICIDADES SU CONTRATO FUE CREADO EXITOSAMENTE!"
        type="success"
      >
      </el-alert>
      <br />
      <b
        ><small
          >A continuación se detallará la información de su contrato</small
        ></b
      >
      <br />
      <br />
      <div v-if="$route.params.tipo_contrato === 'Propio'">
        <el-row :gutter="20">
          <el-col :sm="24">
            <br />
            <b><span style="font-size: 18px">INFORMACIÓN DEL CONTRATO</span></b>
            <hr />
            <br />
          </el-col>
          <el-col :sm="11">
            <b><span style="color: #f67b2f">Nombre del contrato</span></b>
            <br /><br />
            {{ $route.params.nombre }}
          </el-col>
          <el-col :sm="4">
            <b><span style="color: #f67b2f">Tipo de contrato</span></b>
            <br /><br />
            {{ $route.params.tipo_contrato }}
          </el-col>
          <el-col :sm="4">
            <b><span style="color: #f67b2f">Área</span></b>
            <br /><br />
            {{ getArea($route.params.area_id) }}
          </el-col>
          <el-col :sm="5">
            <b><span style="color: #f67b2f">Faena</span></b>
            <br /><br />
            {{ getFaena($route.params.faena_id) }}
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="20">
          <el-col :sm="24">
            <br />
            <b><span style="font-size: 18px">LISTADO DE USUARIOS</span></b>
            <hr />
            <br />
          </el-col>
          <el-col :sm="5">
            <b><span style="color: #f67b2f">Coordinador</span></b>
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores.coordinator"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
          <el-col :sm="5">
            <b><span style="color: #f67b2f">Especialista de Riesgo</span></b>
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores.risk"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
          <el-col :sm="5">
            <b><span style="color: #f67b2f">Especialista de Salud</span></b>
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores.health"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
          <el-col :sm="5">
            <b><span style="color: #f67b2f">Especialista de Seguridad</span></b>
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores.safety"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="20">
          <el-col :sm="5">
            <b
              ><span style="color: #f67b2f"
                >Especialista de Medioambiente</span
              ></b
            >
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores.environment"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
        </el-row>
        <br /><br /><br />
        <el-alert
          :closable="false"
          show-icon
          title="Para comenzar a crear tu inventario de riesgos debes hacer clic en el botón Finalizar e ingresar con tu usuario y contraseña a la plataforma Inventario de Riesgos HSE Online."
          type="warning"
        >
        </el-alert>
        <br /><br />
        <center>
          <el-button @click="finalizar" type="primary" icon="el-icon-success"
            >Finalizar</el-button
          >
        </center>
      </div>
      <div v-else>
        <el-row :gutter="20">
          <el-col :sm="24">
            <br />
            <b><span style="font-size: 18px">INFORMACIÓN DEL CONTRATO</span></b>
            <hr />
            <br />
          </el-col>
          <el-col :sm="12">
            <b><span style="color: #f67b2f">Nombre del contrato</span></b>
            <br /><br />
            {{ $route.params.nombre }}
          </el-col>
          <el-col :sm="4">
            <b><span style="color: #f67b2f">Tipo de contrato</span></b>
            <br /><br />
            {{ $route.params.tipo_contrato }}
          </el-col>
          <el-col :sm="4">
            <b><span style="color: #f67b2f">Área</span></b>
            <br /><br />
            {{ getArea($route.params.area_id) }}
          </el-col>
          <el-col :sm="4">
            <b><span style="color: #f67b2f">Faena</span></b>
            <br /><br />
            {{ getFaena($route.params.faena_id) }}
          </el-col>
        </el-row>
        <br /><br />
        <el-row :gutter="20">
          <el-col :sm="8">
            <b><span style="color: #f67b2f">Alcance del Contrato</span></b>
            <br /><br />
            {{ $route.params.alcance }}
          </el-col>
          <el-col :sm="8">
            <b><span style="color: #f67b2f">Alcance del Trabajo</span></b>
            <br /><br />
            {{ $route.params.alcance_trabajo }}
          </el-col>
          <el-col :sm="4">
            <b><span style="color: #f67b2f">Fecha Inicio</span></b>
            <br /><br />
            {{ $route.params.fecha_inicio | moment("DD MMMM YYYY") }}
          </el-col>
          <el-col :sm="4">
            <b><span style="color: #f67b2f">Fecha Fin</span></b>
            <br /><br />
            {{ $route.params.fecha_fin | moment("DD MMMM YYYY") }}
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="20">
          <el-col :sm="24">
            <br />
            <b><span style="font-size: 18px">LISTADO DE USUARIOS</span></b>
            <hr />
            <br />
          </el-col>
          <el-col :sm="5">
            <b><span style="color: #f67b2f">Coordinador Contratista</span></b>
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores
                .contractor_coordinator"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
          <el-col :sm="5">
            <b><span style="color: #f67b2f">HSE Contratista</span></b>
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores.contractor_hse"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
          <el-col :sm="5">
            <b
              ><span style="color: #f67b2f">Administrador de Contratos</span></b
            >
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores.administrator"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
          <el-col :sm="5">
            <b><span style="color: #f67b2f">Dueño de Contrato</span></b>
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores.owner"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
        </el-row>
        <br /><br />
        <el-row :gutter="20">
          <el-col :sm="5">
            <b><span style="color: #f67b2f">Especialista de Riesgo</span></b>
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores.risk"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
          <el-col :sm="5">
            <b><span style="color: #f67b2f">Especialista de Salud</span></b>
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores.health"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
          <el-col :sm="5">
            <b><span style="color: #f67b2f">Especialista de Seguridad</span></b>
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores.safety"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
          <el-col :sm="5">
            <b
              ><span style="color: #f67b2f"
                >Especialista de Medioambiente</span
              ></b
            >
            <br /><br />
            <li
              style="list-style: none"
              v-for="(item, index) in $route.params.revisores.environment"
              :key="index"
            >
              {{ getUsers(item) }}
            </li>
          </el-col>
        </el-row>
        <br /><br /><br />
        <el-alert
          :closable="false"
          show-icon
          title="Para comenzar a crear tu inventario de riesgos debes hacer clic en el botón Finalizar e ingresar con tu usuario y contraseña a la plataforma Inventario de Riesgos HSE Online."
          type="warning"
        >
        </el-alert>
        <br /><br />
        <center>
          <el-button @click="finalizar" type="primary" icon="el-icon-success"
            >Finalizar</el-button
          >
        </center>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import moment from "moment-timezone";
import axios from "axios";
export default {
  data() {
    return {
      usersFaena: [],
      areas: [],
      faenas: [],
    };
  },
  components: {
    Header,
  },
  async created() {
    await this.getUsersFaena(this.$route.params.faena_id);
    await this.getAreas(this.$route.params.faena_id);
    await this.getFaenas(this.$route.params.faena_id);
  },
  methods: {
    finalizar() {
      this.$router.push({ name: "homePage" });
    },
    async getFaenas(faena_id) {
      let response = await axios.get(`/data-science/faenas`);
      this.faenas = response.data;
    },
    async getAreas(faena_id) {
      let response = await axios.get(`/data-science/areas/${faena_id}`);
      this.areas = response.data;
    },
    async getUsersFaena(faena_id) {
      this.loading = true;
      let response = await axios.get(`/data-science/usuarios/${faena_id}`);
      this.usersFaena = response.data.usersFaena;
      this.loading = false;
    },
    getUsers(id) {
      let user = this.usersFaena.find((x) => x._id === id);
      if (user) {
        return `${user.nombre} ${user.apellido}`;
      } else {
        return "";
      }
    },
    getArea(id) {
      let area = this.areas.find((x) => x._id === id);
      if (area) {
        return area.nombre;
      } else {
        return "";
      }
    },
    getFaena(id) {
      let faena = this.faenas.find((x) => x._id === id);
      if (faena) {
        return faena.nombre;
      } else {
        return "";
      }
    },
  },
};
</script>